import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreditCardPaymentComponent } from './credit-card-payment.component';
import { SsnInputModule } from '../ssn-input/ssn-input.module';
import { NumberOnlyDirective } from 'src/app/shared/directives/numberOnly.directive';
import { NamePatternDirective } from 'src/app/shared/directives/namePattern.directive';
import { ZipCodeDirective } from '../../directives/zipCode.directive';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    MatBottomSheetModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    SsnInputModule,
    MatSelectModule,
    PipesModule,
    NumberOnlyDirective,
    NamePatternDirective,
    ZipCodeDirective
  ],
  declarations: [CreditCardPaymentComponent],
  exports: [CreditCardPaymentComponent]
})
export class CreditCardPaymentComponentModule {}
